export default function TextPreview({ src }: { src: string }) {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <iframe className="h-[32rem] w-[50vw] overflow-scroll" src={src} />
    </div>
  );
}
